import * as Yup from 'yup';

export default Yup.object().shape({
    reason: Yup.string().required("This field is required"),
    confirmDeauthorise: Yup.bool()
        .required("You must confirm this action")
        .oneOf([true], "You must confirm this action"),
});